import { render } from "./edit-contrat-form.vue?vue&type=template&id=4c8ac342"
import script from "./edit-contrat-form.vue?vue&type=script&lang=js"
export * from "./edit-contrat-form.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__